module.exports = __webpack_public_path__ + "img/line_width_ico.0b4fe3e8.svg";